export interface CatalogPermissionUserConfigConstructor {
  id: number
  fullName: string
  email: string
  grantedSecondaryCategoryIds: number[]
}

export class CatalogPermissionUserConfig {
  readonly id: number
  readonly fullName: string
  readonly email: string
  readonly grantedSecondaryCategoryIds: number[]

  constructor(data: CatalogPermissionUserConfigConstructor) {
    this.id = data.id
    this.fullName = data.fullName
    this.email = data.email
    this.grantedSecondaryCategoryIds = data.grantedSecondaryCategoryIds
  }

  get displayName(): string {
    return this.fullName.trim() || this.email
  }

  isSecondaryCategoryGranted(secondaryCategoryId: number): boolean {
    return this.grantedSecondaryCategoryIds.includes(secondaryCategoryId)
  }
}
